import {camelizeKeys, decamelizeKeys} from "humps";

export default {
  validateOrganizationCode(organizationCode) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/organizations/validate_organization_code",
        type: "POST",
        data: decamelizeKeys({ organizationCode }),
        success: response => resolve(camelizeKeys(response).result),
        error: response => reject(response.responseJSON)
      });
    });
  },

  join(organizationCode, user, createNewAccount, npi, portal) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/organizations/join",
        type: "POST",
        data: decamelizeKeys({ organizationCode, createNewAccount, user, npi, portal }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  }
}